import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyPaginatorModule } from '@angular/material/legacy-paginator';
import { AllItemsGridDirective } from '@portal-core/ui/grid/directives/all-items-grid/all-items-grid.directive';

@NgModule({
  declarations: [
    AllItemsGridDirective,
  ],
  imports: [
    CommonModule,
    MatLegacyPaginatorModule
  ],
  exports: [
    AllItemsGridDirective
  ]
})
export class AllItemsGridDirectiveModule { }
